export default __webpack_public_path__ + "static/media/file-sync.96ce9e94.svg";